import { axiosClient } from '@src/api/apiClient/axiosClient';

export const companyLogoutApiClient = {
  logout: async () => {
    await axiosClient.post('/company/auth/logout', {});
  },
};
